import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useAddProductMutation,
  useDeleteProductMutation,
  useGetProductsQuery,
  useUpdateProductMutation,
} from "../../services/API/titanApi";
import {
  selectAddNewState,
  selectCurrentTable,
  setAddNewState,
  setCurrentTable,
} from "../../store/slices/dataTablesSlice";
import Products from "../DataTables/Products";
import { TableTitle } from "./TableTitle";

export function TablesBasePageTragglieder() {
  const tableTitle = useSelector(selectCurrentTable);
  const [errorMessage, setErrorMessage] = useState();
  const [addNewProduct] = useAddProductMutation();
  const [deleteProduct] = useDeleteProductMutation();
  const [updateProduct] = useUpdateProductMutation();

  const isNewStateOn = useSelector(selectAddNewState);
  const dispatch = useDispatch();

  const productFunctions = {
    abort: abort,
    getNew: function () {
      return { aashto: false, germany: false, eurocode: false };
    },
    addNew: async (localdata) => {
      try {
        let test = await addNewProduct(localdata).unwrap();
        dispatch(setAddNewState(false));
        setErrorMessage(null);
      } catch (error) {
        console.error(error);
        setErrorMessage(error.data.message);
      }
    },
    delete: async (id) => {
      try {
        await deleteProduct(id);
      } catch (error) {
        console.error("error ", error);
      }
      dispatch(setAddNewState(false));
    },
    update: async (localdata) => {
      try {
        await updateProduct(localdata).unwrap();
      } catch (error) {
        console.error("in Product Update: ", error);
      }
      dispatch(setAddNewState(false));
    },
    GetAll: () => {
      return useGetProductsQuery();
    },
  };

  const titlesConfig = [
    {
      title: "Products",
      component: <Products functions={productFunctions} />,
      functions: productFunctions,
    },
  ];

  function abort() {
    dispatch(setAddNewState(false));
    setErrorMessage(null);
  }

  const [currentComponent, setCurrentComponent] = useState(
    titlesConfig.find((obj) => {
      return obj.title === tableTitle.products;
    })?.component ?? titlesConfig[0].component
  );

  const [currentFunctions, setCurrentFunctions] = useState(
    titlesConfig.find((obj) => {
      return obj.title === tableTitle.products;
    })?.functions ?? titlesConfig[0].functions
  );

  function onSelectedChanged(title) {
    dispatch(setCurrentTable({ ...tableTitle, products: title }));
    setCurrentComponent(getCurrent(title).component);
    setCurrentFunctions(getCurrent(title).functions);
  }

  useEffect(() => {
    setCurrentComponent(getCurrent(tableTitle?.products)?.component ?? titlesConfig[0].component);
  }, [tableTitle.products, isNewStateOn]);

  useEffect(() => {
    setCurrentComponent(getCurrent(tableTitle?.products)?.component ?? titlesConfig[0].component);
    setCurrentFunctions(getCurrent(tableTitle?.products)?.functions ?? titlesConfig[0].functions);
  }, [tableTitle.products]);

  useEffect(() => {}, [errorMessage]);
  function getCurrent(title) {
    let result = titlesConfig.find((item) => item.title == title) || null;
    return result;
  }

  return (
    <div className="TablesBasePage">
      <div className="container-fluid">
        <div className="table-wrapper">
          <TableTitle
            tableTitle={tableTitle.products}
            titles={titlesConfig}
            functions={currentFunctions}
            onSelectedChanged={onSelectedChanged}
          />
          {currentComponent || <div>Daten tabelle noch nicht aktiv</div>}
        </div>
        {errorMessage && <div>{errorMessage || ""}</div>}
      </div>
    </div>
  );
}

export default TablesBasePageTragglieder;
